<template>
  <div class="totalContainer">
    <div class="navigationPage__header">
      <div
        class="itemNav"
        @click="toPage(item.path)"
        v-for="(item, index) in navList"
        :key="index"
      >
        <div class="itemIcon">
          <img :src="item.icon" alt="" />
        </div>
        <div class="itemTitle">{{ item.name }}</div>
        <div class="itemSUbtitle" v-html="item.subtitle"></div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "NavigationPage",
  data() {
    return {
      navList: [
        {
          name: "活动",
          subtitle: "La Actividad",
          path: "/painting/activityHome",
          icon: require("../assets/image/huodong.png"),
        },
        {
          name: "报名",
          subtitle: "Registro",
          path: "/painting/signupPage",
          icon: require("../assets/image/baoming.png"),
        },
        {
          name: "往期作品",
          subtitle: "Trabajos<br/>previos",
          path: "/painting/previousWorks",
          icon: require("../assets/image/wangqi.png"),
        },
        {
          name: "作品展示",
          subtitle: "Galería",
          path: "/painting/listofWorks",
          icon: require("../assets/image/zuopin.png"),
        },
      ],
    };
  },
  methods: {
    toPage(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style lang="less">
.totalContainer {
  width: 100%;
  height: 100%;
}

.navigationPage__header {
  width: 100px;
  background-color: white;
  position: fixed;
  right: 20px;
  top: 240px;
  border-radius: 100px;
  padding-top: 71px;
  padding-bottom: 30px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  .itemNav {
    text-align: center;
    margin-bottom: 34px;
    cursor: pointer;

    .itemIcon {
      width: 40px;
      height: 40px;
      margin: 0 auto;
    }

    .itemTitle {
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      margin-top: 5px;
    }
    .itemSUbtitle {
      color: #666;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      margin-top: 5px;
    }
  }
}
</style>